import { useToast } from '@chakra-ui/react';
import { useRef } from 'react';
import { CustomToast } from '../components/common/CustomToast';

export const useGlobalToast = () => {
	const toast = useToast();
	const queue = useRef([]);

	const showToast = ({ title, status, position }) => {
		if (queue.current.length >= 2) {
			toast.close(queue.current[0]);
			queue.current.shift();
		}

		const id = toast({
			position: position || 'top-right',
			duration: 3000,
			isClosable: true,
			render: () => <CustomToast title={title} status={status} />,
			onCloseComplete: () => {
				queue.current = queue.current.filter((t) => t !== id);
			},
		});

		queue.current.push(id);
	};

	return showToast;
};
